export enum NAFGTMEvent {
  checkoutFunnel = 'checkout_funnel',
  checkoutAction = 'checkout_action',
  addToCart = 'add_to_cart',
  removeFromCart = 'remove_from_cart',
  beginCheckout = 'begin_checkout',
  purchase = 'purchase',
  paymentCancelled = 'payment_cancelled',
  addShippingInfo = 'add_shipping_info',
  addPaymentInfo = 'add_payment_info',
  bilmodell = 'bilmodell',
  viewItem = 'view_item',
  selectItem = 'select_item',
  accordionOpen = 'accordion_open',
  tabNavigation = 'tab_navigation',
  abExperimentParticipant = 'ab_experiment_participant',
  virtualPageView = 'virtualPageView',
  login = 'login',
  logout = 'logout',
  viewPromotion = 'view_promotion',
  selectPromotion = 'select_promotion',
  mittNafMessageView = 'mittnaf_message_view',
  mittNafMessageCtaClick = 'mittnaf_message_cta_click',
  addFavoriteBenefit = 'add_favorite_benefit',
  removeFavoriteBenefit = 'remove_favorite_benefit',
}
